define.alias("shared/components/shared/post/secondary/caption-writer/info-modal", "settings/components/shared/post/secondary/caption-writer/info-modal");